import { CSSProperties, PropsWithChildren } from 'react';
import styles from './styles.module.css';

type DrawerFallbackProps = PropsWithChildren<{
  style?: CSSProperties;
}>;

export default function DrawerFallback(props: DrawerFallbackProps) {
  const { style = {}, children } = props;
  return (
    <div style={style} className={styles.fixacao}>
      {children}
    </div>
  );
}
